/**
 * GP-573 / release 2138 review — prescriber title deploy coupling.
 *
 * The vial-label and receipt templates stopped prefixing "Dr." because the NEW
 * backend (2.3.517) resolves the title from Kroll's practitioner designation
 * server-side and sends `doctorName` ALREADY prefixed ("NP Salvano, Lorraine",
 * "Dr. Chow, Andrew" — see backend common/kroll/prescriber-title.ts). But while
 * an OLD backend is still serving, `doctorName` arrives bare ("Chow, Andrew")
 * and the new frontend printed physicians with no title at all.
 *
 * This is a transitional compatibility shim, not a patient-data default:
 *   - `prescriberTitle === undefined` → the backend didn't say. Fall back to
 *     the PRE-EXISTING behaviour: prefix "Dr." — unless the name already leads
 *     with a designation title the new backend embeds (never "Dr. NP …").
 *   - `prescriberTitle === ''`        → the backend answered "no title": print
 *     the name bare.
 *   - `prescriberTitle === 'NP'` etc. → print that title.
 *
 * TODO(remove after 2.3.517 backend is live): collapse this to a verbatim
 * pass-through of `doctorName` once no old backend can be serving.
 */

/**
 * The titles the backend's prescriber-title map can emit
 * (PRESCRIBER_TITLE_BY_DESIGNATION + DEFAULT_PRESCRIBER_TITLE). Used only to
 * recognise an already-titled name — the titles themselves are always resolved
 * server-side from Kroll's designation, never here.
 */
const ALREADY_TITLED = /^(Dr\.|NP|RPh|RN)\s/;

export function formatPrescriberName(
  doctorName: string | null | undefined,
  prescriberTitle?: string,
): string {
  const name = (doctorName || '').trim();
  if (!name) return '';

  if (prescriberTitle === undefined) {
    // TODO(remove after 2.3.517 backend is live) — old-backend fallback.
    return ALREADY_TITLED.test(name) ? name : `Dr. ${name}`;
  }
  if (prescriberTitle === '') return name;
  return `${prescriberTitle} ${name}`;
}
